import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiService from '../../../services/api';
import LegendaRelatorio from './LegendaRelatorio';
import PainelFiltros from './PainelFiltros';
import PainelOrdenacao from './PainelOrdenacao';
import TabelaRelatorio from './TabelaRelatorio';
import { Mensagem } from './estilos';

const SEM_OPCOES = { areas: [], setores: [] };

const RelatorioConcessaoContent = ({ relatorio, painelAberto, filtros, atualizar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [itens, setItens] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);
  const [opcoes, setOpcoes] = useState(SEM_OPCOES);

  useEffect(() => {
    let ativo = true;
    apiService
      .getOpcoesRelatorioConcessao(relatorio)
      .then((resposta) => ativo && setOpcoes(resposta))
      .catch(() => ativo && setOpcoes(SEM_OPCOES));
    return () => {
      ativo = false;
    };
  }, [relatorio]);

  useEffect(() => {
    let ativo = true;
    setCarregando(true);
    setErro(null);
    apiService
      .getRelatorioConcessao(relatorio, filtros)
      .then((resposta) => {
        if (!ativo) return;
        setItens(resposta.itens);
        setCarregando(false);
      })
      .catch((falha) => {
        if (!ativo) return;
        setErro(falha.message || 'Falha ao carregar o relatório.');
        setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, [relatorio, filtros]);

  const visualizar = (solicitacaoId) =>
    navigate(`/RelatorioConcessao/${relatorio}/${solicitacaoId}`, {
      state: { voltarPara: `${location.pathname}${location.search}` },
    });

  return (
    <>
      {painelAberto === 'filtros' && (
        <PainelFiltros filtros={filtros} opcoes={opcoes} onAplicar={atualizar} />
      )}
      {painelAberto === 'ordenacao' && (
        <PainelOrdenacao ordenarPor={filtros.ordenarPor} ordem={filtros.ordem} onAplicar={atualizar} />
      )}
      <LegendaRelatorio />
      {carregando && <Mensagem>Carregando...</Mensagem>}
      {!carregando && erro && <Mensagem>{erro}</Mensagem>}
      {!carregando && !erro && <TabelaRelatorio itens={itens} onVisualizar={visualizar} />}
    </>
  );
};

export default RelatorioConcessaoContent;
